// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QmB6","col":"styles_col__2UtfC"};